import React from 'react';
import Main from 'gatsby-matrix-theme/src/gatsby-core-theme/components/molecules/main';

export default function index(props) {
  const hideNewsletter =props?.pageContext?.page?.template === 'responsible_gambling_guide';
  
  return (
    <Main {...props} showAuthor={false} isStickyNewsletter exclNewsletter={hideNewsletter} />
  )
}